module.exports = __webpack_public_path__ + "resources/img/banner-2.8b5966c4.png";